export const ImagingTypeSelector = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
  gap: 'Z',

  PeriapicalOption: {
    flow: 'y', gap: 'Y', padding: 'A', round: 'Z', cursor: 'pointer',
    border: (el, s) => s.root.selectedImagingType === 'Periapical' ? '2px solid teal' : '1px solid inkBorder',
    background: (el, s) => s.root.selectedImagingType === 'Periapical' ? 'teal.15' : 'inkSurface',
    onClick: (e, el, s) => s.root.update({ selectedImagingType: 'Periapical' }),
    Icon: { text: '\uD83E\uDDB7', fontSize: 'C' },
    Label: { text: '{{ periapical | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'inkText' },
    Desc: { text: '{{ singleToothView | polyglot }}', fontSize: 'Y', color: 'inkMuted' }
  },

  PanoramicOption: {
    flow: 'y', gap: 'Y', padding: 'A', round: 'Z', cursor: 'pointer',
    border: (el, s) => s.root.selectedImagingType === 'Panoramic' ? '2px solid teal' : '1px solid inkBorder',
    background: (el, s) => s.root.selectedImagingType === 'Panoramic' ? 'teal.15' : 'inkSurface',
    onClick: (e, el, s) => s.root.update({ selectedImagingType: 'Panoramic' }),
    Icon: { text: '\uD83C\uDF05', fontSize: 'C' },
    Label: { text: '{{ panoramic | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'inkText' },
    Desc: { text: '{{ fullMouthView | polyglot }}', fontSize: 'Y', color: 'inkMuted' }
  },

  CbctOption: {
    flow: 'y', gap: 'Y', padding: 'A', round: 'Z', cursor: 'pointer',
    border: (el, s) => s.root.selectedImagingType === 'CBCT' ? '2px solid teal' : '1px solid inkBorder',
    background: (el, s) => s.root.selectedImagingType === 'CBCT' ? 'teal.15' : 'inkSurface',
    onClick: (e, el, s) => s.root.update({ selectedImagingType: 'CBCT' }),
    Icon: { text: '\uD83D\uDDA5\uFE0F', fontSize: 'C' },
    Label: { text: 'CBCT', fontSize: 'Z', fontWeight: '600', color: 'inkText' },
    Desc: { text: '3D Imaging', fontSize: 'Y', color: 'inkMuted' }
  },

  CephalometricOption: {
    flow: 'y', gap: 'Y', padding: 'A', round: 'Z', cursor: 'pointer',
    border: (el, s) => s.root.selectedImagingType === 'Cephalometric' ? '2px solid teal' : '1px solid inkBorder',
    background: (el, s) => s.root.selectedImagingType === 'Cephalometric' ? 'teal.15' : 'inkSurface',
    onClick: (e, el, s) => s.root.update({ selectedImagingType: 'Cephalometric' }),
    Icon: { text: '\uD83D\uDC64', fontSize: 'C' },
    Label: { text: '{{ cephalometric | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'inkText' },
    Desc: { text: '{{ lateralSkullView | polyglot }}', fontSize: 'Y', color: 'inkMuted' }
  }
}
